import React from 'react';
import { useTheme } from '@context/ThemeContext';

interface TextProps extends React.HTMLAttributes<HTMLElement> {
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'label';
  color?: string;
}

export const Text: React.FC<TextProps> = ({
  variant = 'p',
  children,
  color,
  className,
  ...props
}) => {
  const Element = variant === 'span' || variant === 'label' ? variant : 'p';

  const variantStyles = {
    h1: 'text-4xl font-bold',
    h2: 'text-3xl font-bold',
    h3: 'text-2xl font-bold',
    h4: 'text-xl font-semibold',
    h5: 'text-lg font-semibold',
    h6: 'text-base font-semibold',
    p: 'text-base',
    span: 'text-base',
    label: 'text-sm',
  };

  const { themeConfig } = useTheme();
  const resolvedColor = color || themeConfig.header.text;

  return (
    <Element
      className={`${variantStyles[variant]} ${resolvedColor} ${className || ''}`}
      {...props}
    >
      {children}
    </Element>
  );
};
